import { createFileRoute } from '@tanstack/react-router';

import { AdminView } from 'src/sections/admin/view';

export const Route = createFileRoute('/admin-skidog/organizations')({
  component: AdminOrganizationsPage,
});

function AdminOrganizationsPage() {
  return <AdminView />;
}
